<template>
  <v-menu
    ref="menu"
    :close-on-content-click="false"
    v-model="showDatePicker"
    transition="scale-transition"
    offset-y
    full-width
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        :label="label"
        v-on="on"
        v-model="startDateUK"
        prepend-icon="event"
        hide-details
        readonly
      ></v-text-field>
    </template>
    <v-date-picker
      v-model="dateModel"
      @input="$refs.menu.save(dateModel)"
      min="2016-06-20"
      no-title
      first-day-of-week="1"
    >
      <v-spacer></v-spacer>
      <v-btn text color="primary" @click="showDatePicker = false">Cancel</v-btn>
    </v-date-picker>
  </v-menu>
</template>

<script>
import moment from 'moment';

export default {
  name: 'AbfDatePicker',
  props: ['label', 'value'],
  data: () => ({
    dateModel: moment().format('YYYY-MM-DD'),
    showDatePicker: false
  }),
  computed: {
    startDateUK() {
      this.$emit('input', this.dateModel);
      return moment(this.dateModel).format('DD/MM/YYYY');
    }
  },
  watch: {
    value(newDate) {
      this.dateModel = moment(newDate).format('YYYY-MM-DD');
    }
  }
};
</script>
